import { render, staticRenderFns } from "./home2026.vue?vue&type=template&id=af9df796&scoped=true"
import script from "./home2026.vue?vue&type=script&lang=js"
export * from "./home2026.vue?vue&type=script&lang=js"
import style0 from "./home2026.vue?vue&type=style&index=0&id=af9df796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9df796",
  null
  
)

export default component.exports